
import PickerCalendar from './calendar/calendar.js'
import PickerDatetime from './datetime/datetime.js'
import PickerRelation from './relation/relation.js'
import PickerGrade from './grade/grade.js'
import PickerGender from './gender/gender.js'
import PickerTimeInterval from './time-interval/time-interval.js'
import PickerAgeMonth from './age-month/age-month.js'
import PickerDictionary from './dictionary/dictionary.js'
import PickerDateRange from './dateRange/dateRange.js'
import NotifyBindAccount from './notify-bind-account/notify-bind-account.js'
import commentPoster from './comment-poster/comment-poster.js'

let picker = {}

Vue.use(PickerCalendar, {
    router: VueRouter.router,
    root: picker
});

Vue.use(PickerDatetime, {
    router: VueRouter.router,
    root: picker
});

Vue.use(PickerRelation, {
    router: VueRouter.router,
    root: picker
});

Vue.use(PickerGrade, {
    router: VueRouter.router,
    root: picker
});

Vue.use(PickerGender, {
    router: VueRouter.router,
    root: picker
});

Vue.use(PickerTimeInterval, {
    router: VueRouter.router,
    root: picker
});

Vue.use(PickerDictionary, {
    router: VueRouter.router,
    root: picker
});

Vue.use(PickerDateRange, {
    router: VueRouter.router,
    root: picker
});

Vue.use(NotifyBindAccount, {
    router: VueRouter.router,
    root: picker
});

Vue.use(commentPoster, {
    router: VueRouter.router,
    root: picker
});

Vue.use(PickerAgeMonth, {
    router: VueRouter.router,
    root: picker
});

export default picker;